import { CITY_TITLE, COMPANY_TITLE, NO_PERSONAL_TITLE } from './constants';

export function formatCommissioningContactPerson(contactPerson = {}) {
  /* Overview: company_name,
     Detailpage: organization_name */
  const title =
    contactPerson.title === NO_PERSONAL_TITLE ? null : contactPerson.title;
  let organizationName = null;

  if (title === COMPANY_TITLE) {
    organizationName =
      contactPerson.company_name || contactPerson.organization_name;
  }

  if (title === CITY_TITLE) {
    organizationName =
      contactPerson.city_name ||
      contactPerson.organization_name ||
      contactPerson.company_name;
  }

  return [title, organizationName, contactPerson.name, contactPerson.surname]
    .filter(Boolean)
    .join(' ');
}
